<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-10-25 14:59:59
-->
<template>
  <div class="login-container scim-common-theme scim-common-theme-green">
    <logo-head />
    <loading v-if="showFullLoading"></loading>
    <div class="login-container-min">
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form-min"
        auto-complete="on"
        label-position="left"
      >
        <div class="loginleft-container-min">
          <div class="image-min-container">
            <img class="image-min" src="@/assets/images/rootlogin.png" />
          </div>
          <h3 class="title-min">
            {{ $t('login.logIn') }}
            <span v-if="lang === 'zh'">{{ $t('title.headerTitle') }}</span>
          </h3>
          <span class="letter letter-top">{{ $t('login.account') }}</span>
          <el-form-item prop="username">
            <el-input
              ref="username"
              v-model="loginForm.username"
              :placeholder="$t('login.accountPlaceholder')"
              name="username"
              type="text"
              tabindex="1"
            />
          </el-form-item>
          <span class="letter">{{ $t('login.password') }}</span>
          <el-form-item prop="password" class="password">
            <el-input
              :key="passwordType"
              ref="password"
              v-model="loginForm.password"
              :type="passwordType"
              :placeholder="$t('login.enterPassword')"
              name="password"
              tabindex="2"
              auto-complete="on"
            />
            <span class="show-pwd" @click="showPwd">
              <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </el-form-item>

          <el-button
            :loading="loading"
            type="primary"
            class="button-login"
            @click.native.prevent="handleLogin"
          >
            {{ $t('login.logIn') }}
          </el-button>
        </div>
        <!-- <div class="code-and-forget">
          <span v-show="false" class="login-code">{{ $t('login.codeLogin') }}</span>
          <span class="forget-password-letter" @click="getBackPassword">
            {{ $t('login.forgetPassword') }}
          </span>
        </div> -->
        <!--原型图中没有中英文切换-->
        <!-- <div class="footer" >
          <span class="cursor-p cut-line" :class="{active: lang === 'zh'}" type="text" @click="handleChangeLang('zh')">中文</span>
          <span class="cursor-p" :class="{active: lang === 'en'}" @click="handleChangeLang('en')">English</span>
        </div>-->
      </el-form>
      <span class="agree-min agree">
        <span class="agree-letter">{{ $t('login.agree') }}</span>
        <a
          href="https://developer.rootcloud.com/policy/service/"
          target="_blank"
          class="agree-target"
        >
          {{ $t('login.service') }}
        </a>
        <span class="agree-letter">{{ $t('login.and') }}</span>
        <a
          href="https://developer.rootcloud.com/policy/privacy/"
          target="_blank"
          class="agree-target"
        >
          {{ $t('login.privacy') }}
        </a>
      </span>
    </div>
    <img src="@/assets/images/login-pic.png" class="login-image-min" />

    <img src="@/assets/images/login.png" class="login-image-max" />
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      auto-complete="on"
      label-position="left"
    >
      <div class="loginleft-container">
        <div class="title-container">
          <div class="title-container-left">
            <img src="@/assets/images/rootlogin.png" alt class="login-root-png" />
            <h3 v-if="lang === 'zh'" class="title">
              {{ $t('login.logIn') }}{{ $t('title.headerTitle') }}
              <!-- <span v-if="lang === 'zh'">{{ $t("title.headerTitle") }}</span> -->
            </h3>
            <h3 v-else class="title">
              {{ $t('login.logIn') }}
              <!-- <span v-if="lang === 'zh'">{{ $t("title.headerTitle") }}</span> -->
            </h3>
          </div>
          <!--暂时隐藏掉验证码登录
          <span class="login-code" @click="changeLoginWay">
            {{ getCodeLogin ? $t("login.passwordLogin") : $t("login.codeLogin") }}
          </span>
          -->
        </div>
        <span v-if="!getCodeLogin" class="letter letter-top">{{ $t('login.account') }}</span>
        <el-form-item v-if="!getCodeLogin" prop="username">
          <el-input
            ref="username"
            v-model.trim="loginForm.username"
            :placeholder="$t('login.accountPlaceholder')"
            name="username"
            type="text"
            tabindex="1"
            auto-complete="on"
          />
        </el-form-item>
        <span v-if="!getCodeLogin" class="letter">{{ $t('login.password') }}</span>
        <el-form-item v-if="!getCodeLogin" prop="password" class="password">
          <el-input
            :key="passwordType"
            ref="password"
            v-model.trim="loginForm.password"
            :type="passwordType"
            :placeholder="$t('login.enterPassword')"
            name="password"
            tabindex="2"
            auto-complete="on"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
        <span v-if="getCodeLogin" class="letter letter-top">{{ $t('login.account') }}</span>
        <el-form-item v-if="getCodeLogin" prop="cellphone">
          <el-input
            v-model.trim="loginForm.cellphone"
            :placeholder="$t('login.accountForPhone')"
            tabindex="2"
            auto-complete="on"
          />
        </el-form-item>
        <!--验证码模块-->
        <span v-if="getCodeLogin" class="letter">{{ $t('login.verificationCode') }}</span>
        <el-form-item v-if="getCodeLogin" class="code-container" prop="code">
          <el-input
            v-model="loginForm.code"
            class="input codeInput"
            type="text"
            :placeholder="$t('login.codePlaceholder')"
            :maxlength="6"
          />
          <span class="getCode" @click="getCode">{{ showCountDown }}</span>
        </el-form-item>
        <el-button
          :loading="loading"
          type="primary"
          class="button-login"
          @click.native.prevent="handleSlideVerify"
        >
          {{ $t('login.logIn') }}
        </el-button>
        <span class="agree">
          <span class="agree-letter">{{ $t('login.agree') }}</span>
          <a
            href="https://developer.rootcloud.com/policy/service/"
            target="_blank"
            class="agree-target"
          >
            {{ $t('login.service') }}
          </a>
          <span class="agree-letter">{{ $t('login.and') }}</span>
          <a
            href="https://developer.rootcloud.com/policy/privacy/"
            target="_blank"
            class="agree-target"
          >
            {{ $t('login.privacy') }}
          </a>
        </span>
        <!-- <div class="forget-password">
          <span class="forget-password-letter" @click="getBackPassword">
            {{ $t('login.forgetPassword') }}
          </span>
        </div> -->
      </div>

      <el-dialog
        title="请完成安全验证"
        :visible.sync="verifyDialogVisible"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        width="460px"
        custom-class="verify-dialog"
      >
        <!-- 图片滑动验证 -->
        <slide-verify
          ref="slideVerify"
          :l="42"
          :r="10"
          :w="410"
          :h="200"
          :imgs="verifyImages"
          :slider-text="$t('login.slideMessage')"
          @success="handleLogin"
        />
      </el-dialog>
    </el-form>
    <logo-footer class="bottom" />
  </div>
</template>

<script>
import LogoHead from "@/components/common/logoHead/index";
import LogoFooter from "@/components/common/logoFooter/index";
import CryptoJS from "crypto-js";
import { isPoneAvailable } from "@/utils/validate";
import { getLang } from "@/utils/auth";

/* import { _session } from "@/utils/storage";*/
import user from "@/api/other/user";
import { mapGetters } from "vuex";
import Loading from "@/components/common/Loading";
import JSEncrypt from "jsencrypt";
import img1 from "@/assets/images/slideVerify/img1.png";
import img2 from "@/assets/images/slideVerify/img2.png";
import img3 from "@/assets/images/slideVerify/img3.png";
import img4 from "@/assets/images/slideVerify/img4.png";
import img5 from "@/assets/images/slideVerify/img5.png";
import img6 from "@/assets/images/slideVerify/img6.png";

export default {
  name: "Login",
  components: {
    LogoHead,
    LogoFooter,
    Loading
  },
  data() {
    const testCellPhone = (rule, value, callback) => {
      if (isPoneAvailable(value)) {
        callback();
      } else {
        callback(new Error(this.$t("login.enterCorrectPhone")));
      }
    };
    return {
      isCodeIng: false,
      // 获取验证码登录
      showCountDown: this.$t("login.getVerificationCode"),
      codeType: "cellphone",
      getCodeLogin: false,
      lang: getLang(),
      loginForm: {
        username: "",
        password: "",
        cellphone: "",
        code: ""
      },
      loginRules: {
        username: [
          {
            required: true,
            message: this.$t("login.accountPlaceholder"),
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: this.$t("login.enterPassword"),
            trigger: "blur"
          }
        ],
        cellphone: [
          {
            required: true,
            message: this.$t("login.accountForPhone"),
            trigger: "blur"
          },
          { validator: testCellPhone, trigger: "blur" }
        ],
        code: [
          {
            required: true,
            message: this.$t("login.codePlaceholder"),
            trigger: "blur"
          }
        ]
      },
      loading: false,
      passwordType: "password",
      redirect: undefined,
      // 是否使用图片验证
      useVerify: true,
      // 图片滑块验证弹框
      verifyDialogVisible: false,
      // 图片验证地址
      verifyImages: [img1, img2, img3, img4, img5, img6],
      // 公钥
      publicKey: undefined
    };
  },
  computed: {
    ...mapGetters(["showFullLoading"])
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    },
    lang: {
      handler(val) {
        // this.$store.commit('settings/CHANGE_LANG', val)
      },
      immediate: true
    }
  },
  created() {
    this.initData();
    this.initPublicKey();
  },
  mounted() {
    // 监听键盘按下事件
    window.addEventListener("keydown", this.handleKeyDown, true);
  },
  destroyed() {
    // 销毁监听事件
    window.removeEventListener("keydown", this.handleKeyDown, true);
  },
  methods: {
    initData() {
      user.getCaptchaStatus().then(res => {
        const { data } = res;
        // 不需要图片验证
        if (data === "NO") {
          this.useVerify = false;
        }
      });
    },
    handleKeyDown(e) {
      // 获取键值
      const { key, keyCde } = e || window.event;
      if (keyCde === 13 || key === "Enter") {
        // 触发的事件
        this.handleSlideVerify();
      }
    },
    // 初始化公钥
    initPublicKey() {
      user.getPublicKey().then(res => {
        const { data } = res;
        this.publicKey = data;
        this.$utils.localstorage._session.set("publicKey", data);
      });
    },
    handleSlideVerify() {
      if (!this.getCodeLogin && this.useVerify) {
        this.$refs.loginForm &&
          this.$refs.loginForm.validate(valid => {
            if (valid) {
              this.verifyDialogVisible = true;
            }
          });
        return;
      }

      this.handleLogin();
    },
    changeLoginWay() {
      this.getCodeLogin = !this.getCodeLogin;
      this.$nextTick(() => {
        this.$refs.loginForm && this.$refs.loginForm.clearValidate();
      });
    },
    // 获取验证码倒计时
    getCode() {
      this.$refs.loginForm.validateField("cellphone", valid => {
        if (!valid) {
          // console.log(valid)
          if (!this.isCodeIng) {
            this.showValidationButton = true;
            this.isCodeIng = true;
            let time = 60;
            const timer = setInterval(() => {
              time--;
              this.showCountDown = `${this.$t("login.tryAgain") + time}s`;
              if (time <= 0) {
                this.showCountDown = this.$t("login.getVerificationCode");
                this.isCodeIng = false;
                clearInterval(timer);
              }
            }, 1000);

            /*
             * 执行获取验证码
             *  console.log(this.loginForm)
             */
            user
              .getLoginCode(this.loginForm)
              .then(res => {
                // eslint-disable-next-line eqeqeq
                if (res.resultCode == 200) {
                  // console.log('成功了')
                }
              })
              .catch(() => {
                // console.log('报错了')
              });
          }
        } else {
          // console.log('error submit!!')
          return false;
        }
      });
    },
    // 跳转到忘记密码页面
    getBackPassword() {
      this.$router.push({ path: "/getBackPassword" });
    },
    handleChangeLang(lang) {
      this.lang = lang;
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      if (!this.getCodeLogin) {
        this.$refs.loginForm.validate(valid => {
          // 校验通过
          if (valid) {
            // 公钥不存在
            if (!this.publicKey) {
              this.$message.error(this.$t("login.publicKeyError"));
              this.verifyDialogVisible = false;
              this.$refs.slideVerify && this.$refs.slideVerify.reset();
              return;
            }
            this.loading = true;
            const encryptJs = new JSEncrypt();
            encryptJs.setPublicKey(this.publicKey);
            const formData = {
              username: encryptJs.encrypt(this.loginForm.username),
              password: encryptJs.encrypt(this.loginForm.password),
              passwordEncrypted: true
            };
            // console.log(formData)
            this.$store
              .dispatch("user/login", formData)
              .then(
                data => {
                  // console.log("user/login data", data);
                  if (data && data.data && data.data.setPwToken) {
                    // 初始进来需要修改密码
                    this.$utils.localstorage._session.set("setPwToken", data.data.setPwToken);
                    this.$router.push({ path: "/changeInitPassword" });
                  } else {
                    this.$router.push({ path: this.redirect || "/" });
                  }
                  this.loading = false;
                },
                () => {
                  this.loading = false;
                  this.verifyDialogVisible = false;
                  this.$refs.slideVerify && this.$refs.slideVerify.reset();
                }
              )
              .catch(() => {
                this.loading = false;
                this.verifyDialogVisible = false;
                this.$refs.slideVerify && this.$refs.slideVerify.reset();
              });
          } else {
            return false;
          }
        });
      } else {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            // eslint-disable-next-line no-unused-vars
            const cellPhoneBase64 = CryptoJS.enc.Base64.stringify(
              CryptoJS.enc.Utf8.parse(this.loginForm.cellphone)
            );
            this.$store
              .dispatch("user/loginByPhone", this.loginForm)
              .then(data => {
                // console.log(data)
                if (data.resultCode === 200) {
                  /*
                   * setIfLogin(cellPhoneBase64)
                   * console.log('路由跳转开始')
                   */
                  this.$router.push({ path: this.redirect || "/" });
                  // console.log('路由跳转结束')
                }
                this.loading = false;
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            return false;
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$dark_gray: #889aa4;
$themeGreen: #00b259;
$sliderBase: 32px;
@media screen and (min-width: 1200px) {
  .login-image-min,
  .login-container-min {
    display: none;
  }
}
@media screen and (min-width: 560px) and (max-width: 1200px) {
  .login-image-max {
    display: none;
  }
  .login-container-min {
    display: none;
  }
}
@media screen and (max-width: 560px) {
  .login-image-max,
  .login-image-min,
  .app-header,
  .login-form,
  .bottom {
    display: none;
  }
  .agree {
    display: flex;
    justify-content: center;
    width: 100%;
    position: fixed;
    bottom: 10px;
    .agree-letter {
      font-size: 12px;
    }
    .agree-target {
      font-size: 12px;
      margin-top: -3px;
    }
  }
}
.code-container {
  position: relative;
}
.getCode {
  position: relative;
  text-align: right;
  margin-top: -30px;
  padding-right: 10px;
  padding-left: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #00b259;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  float: right;
  line-height: 20px;
  border-left: 1px solid #cbd1de;
}
.code-and-forget {
  width: 90%;
  display: flex;
  flex-direction: row;
  margin-left: 5%;
  .login-code {
    flex: 1;
    padding: 0;
  }
  .forget-password-letter {
    flex: 1;
    margin: auto;
    text-align: right;
  }
}
.image-min-container {
  width: 100%;
  display: flex;
}
.image-min {
  position: relative;
  width: 40px;
  height: 40px;
  margin: auto;
}
.title-min {
  margin-bottom: 50px;
  font-size: 20px;
  color: #282a36;
  font-weight: 700;
  line-height: 40px;
  height: 40px;
  text-align: center;
}
.login-container-min {
  width: 100%;
  height: 100vh;
  background-color: #fff;
}
html,
body,
#scim-common-web {
  background-color: red;
  width: 100%;
}
.password {
  padding: 0;
}
a:hover,
a:link,
a:visited {
  color: #00b259;
}
.forget-password-letter,
.agree-target,
.agree-letter,
.letter,
.login-root-png,
.login-image-max,
.login-image-min {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.forget-password-letter {
  line-height: 14px;
  font-size: 14px;
  color: #00b259;
  float: right;
  margin-top: 36px;
  cursor: pointer;
}
.forget-password {
  width: 100%;
  line-height: 20px;
}
.agree-target {
  line-height: 20px;
  font-size: 14px;
  color: #00b64d;
}
.agree-letter {
  color: #9ea5b2;
  font-size: 14px;
}
.letter-top {
  margin-top: 50px;
}
.title-container-left {
  display: flex;
  height: 40px;
  line-height: 40px;
  .title {
    display: inline-block;
    margin: 0;
    line-height: 40px;
    height: 40px;
    padding-top: 10px;
    margin-top: -10px;
    font-size: 20px;
    color: #282a36;
    font-weight: 700;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
}
.el-form-item__content {
  border: 1px solid #dadfea;
}
.letter {
  display: block;
  font-size: 14px;
  padding-bottom: 12px;
  color: #505363;
}
.login-code {
  color: #00b259;
  font-size: 14px;
  line-height: 40px;
  height: 40px;
  cursor: pointer;
}
.login-root-png {
  width: 40px;
  height: 40px;
  margin-right: 16px;
}
.loginleft-container {
  position: relative;
  width: 410px;
  margin: auto;
  margin-top: 50px;
}
.loginleft-container-min {
  position: relative;
  width: 90%;
  margin: auto;
  margin-top: 50px;
}
/* reset element-ui css */
.login-container {
  .loginleft-container {
    height: 100%;
    .el-input {
      display: inline-block;
      height: 40px;
      width: 100%;
      input {
        background-color: #fff;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px 12px 15px;
        height: 40px;
        &:-webkit-autofill {
          box-shadow: 0 0 0px 1000px #fff inset !important;
        }
      }
    }
  }

  .el-form-item {
    border-radius: 5px;
    color: #454545;
  }
}
.button-login {
  width: 100%;
  margin-top: 16px !important;
  margin-bottom: 19px !important;
}

.login-image-max {
  max-width: 738px;
  max-height: 616px;
  margin: auto 0;
  margin-left: -100px;
}
.login-image-min {
  position: absolute;
  max-width: 798px;
  width: 100%;
  height: 620px;
  align-self: center;
}
.login-container {
  min-height: 100%;
  background-color: #f5f7fa;
  overflow: hidden;
  display: flex;
  justify-content: center;
  .login-form {
    position: relative;
    width: 560px;
    height: 546px;
    overflow: hidden;
    margin-left: 8px;
    margin: auto 0;
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(33, 37, 46, 0.12);
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }
  .title-container {
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    margin-bottom: 17px;
    width: 410px;
    .login-code {
      text-align: right;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 1px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
</style>

<style lang="scss">
/*ie*/
input::-ms-reveal {
  display: none;
}
input::-ms-clear {
  display: none;
}
/*edge*/
input::-o-clear {
  display: none;
}
.loginleft-container,
.loginleft-container-min {
  .el-form-item__error {
    position: relative;
    margin-bottom: 8px;
    font-size: 14px;
  }
  .el-input {
    input {
      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #fff inset !important;
      }
    }
    /* IE11 禁用清除按钮（叉号） */
    input::-ms-clear {
      display: none;
    }
    /* IE11 禁用显示密码按钮（小眼睛） */
    input::-ms-reveal {
      display: none;
    }
  }
}
.marginleftAuto {
  margin-left: 0 !important;
  background: #3377ff !important;
}
.scim-common-theme {
  .login-form {
    .el-dialog__wrapper {
      position: absolute;

      .el-dialog {
        margin-top: 50px !important;
      }

      .el-dialog__title {
        font-weight: bold;
      }

      .el-dialog__body {
        padding: 14px 24px 24px;
      }

      .slide-verify-slider-mask-item {
        top: -1px;
      }
    }
  }
}
</style>
